import logo from "../Images/brand/logo.png"

function ThankyouPage(){
    return <div className="flex flex-col h-full antialiased bg-neutral-800">
        <header className="sticky top-0 z-50 bg-white md:px-24 drop-shadow-md">
            <div className="flex flex-col items-center justify-between gap-4 p-5 md:flex-row">
                <a href="/"><img className="w-40" src={logo} alt="Virtuous LOGO" /></a>
                <a href="/" className="flex items-center gap-4 cta cta-primary">
                <p>All tools</p>
                <i className="ph-caret-right"></i>
                </a>
            </div>
        </header>
        <main className="container relative flex flex-col justify-between gap-8 p-8 mx-auto my-8 md:p-20 card">

            <div className="flex items-center gap-4">
                <div className="flex justify-center gap-4 p-5">
                    
                </div>
            </div>
            <div className="flex flex-col items-center py-40">
                <a href="/"><img className="w-120" src={logo} alt="Virtuous LOGO" /></a>
                <p className="mt-4 text-3xl font-bold">Thaks for your answer!</p>
            </div>

            <div className="flex flex-col items-center gap-4">
                <a className="cta cta-primary" href="/">All tools</a>
            </div>

    </main>     
    </div>
}

export default ThankyouPage